import Header from "../components/Header";
import Fondo2 from "../assets/personas.jpeg"
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";
import IMG1 from "../assets/contactanos.png";
import Footer from "../components/Footer";

const Contact = () => {
    const redes = [
      {name:"", icon:FaWhatsapp, url:"https://api.whatsapp.com/send/?phone=522211001481&text&type=phone_number&app_absent=0"},
      {name:"", icon:FaInstagram, url:"https://www.instagram.com/estrategias.corp0805/"},
      {name:"", icon:FaFacebook, url:"https://www.facebook.com/profile.php?id=100069072834339#"},
    ];

    return (
        <>
            <Header/>
            <div>
                <div
                    className="w-full h-[75vh] relative bg-cover bg-top bg-no-repeat flex flex-col items-start justify-end p-16 gap-6"
                    style={{ backgroundImage: `url(${Fondo2})` }}
                >
                    <h1 className="text-6xl text-white font-bold z-40">Contáctenos</h1>
                    <section className="h-fit w-full grid grid-cols-1 text-white  z-40">
          <div className="grid grid-cols-3 gap-6">
            <div className="grid place-items-left gap-2">
              <h2 className="text-2xl font-bold"> Estamos en linea </h2>
              <p> Tel. 22-11-00-14-81 </p>
              <p> estrategias.corp0805@gmail.com</p>
            </div>
            <div className="grid place-items-left gap-2">
              <h2 className="text-2xl font-bold"> Visítenos </h2>
              <p> 3 B Sur 3705 -1 Col. Gabriel Pastor, Puebla, Puebla C.P 72420</p>
            </div>
            <div className="grid place-items-left gap-2">
              <h2 className="text-2xl font-bold">Horario de oficina</h2>
              <p>Lun - Vie 10:00 am - 7:00 pm</p>
              <p>sÁb -dom Cerrado</p>
            </div>
          </div>
            <div className="w-fit flex flex-row gap-6 pt-4">
            {redes.map((red, index) => {
                const Icon = red.icon;
                return (
                    <a
                    key={index}
                    href={red.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={red.name}
                    className="text-white text-2xl hover:text-yellow-300 transition-colors"
                    >
                    <Icon />
                    </a>
                );
                })}
                </div>
        </section>
                </div>
                <div className="w-full h-auto md:h-[75vh] grid grid-cols-1 md:grid-cols-2 md:px-16 py-6">
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${IMG1})` }} 
            />
<div className="relative w-full h-full flex flex-col justify-center text-left px-4 md:px-0">
  <div className="w-full bg-estra p-20 text-white md:absolute md:-left-16 grid grid-cols-1 gap-6">

                    <h1 className="font-semibold text-2xl">¿Cómo podemos ayudarle?</h1>
                        <form className="flex flex-col gap-4">
      <input
        type="text"
        placeholder="Nombre"
        className="bg-transparent border-b border-white text-white placeholder-white focus:outline-none focus:border-yellow-300"
      />
      <input
        type="email"
        placeholder="Correo electrónico"
        className="bg-transparent border-b border-white text-white placeholder-white focus:outline-none focus:border-yellow-300"
      />
      <textarea
        placeholder="Mensaje"
        rows="3"
        className="bg-transparent border-b border-white text-white placeholder-white focus:outline-none focus:border-yellow-300 resize-none"
      ></textarea>

      <button
        type="submit"
        className="mt-4 px-6 py-2 rounded-full border border-white bg-transparent text-white hover:bg-white hover:text-black transition"
      >
        Enviar
      </button>
    </form>
                </div>
            </div>
        </div>
            </div>
            <Footer/>
        </>
    );
};

export default Contact;